import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  locationData: null,
  loading: false,
  error: null,
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setLocationData: (state, action) => {
      state.locationData = action.payload;
      state.loading = false;
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setLoading, setLocationData, setError } = locationSlice.actions;

// Thunk to fetch location data
export const fetchUserLocation = () => async (dispatch) => {
  // Check if we already have location data in localStorage
  const cachedLocation = localStorage.getItem("userLocation");
  if (cachedLocation) {
    dispatch(setLocationData(JSON.parse(cachedLocation)));
    return;
  }

  dispatch(setLoading());
  try {
    // console.log("zero");
    const response = await fetch("https://ipapi.co/json");
    const data = await response.json();
    // console.log(data, "location data");

    if (data.error) {
      throw new Error(data.reason || "Failed to fetch location");
    }
    // console.log("one");
    const conversionRate = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/country/${data.currency}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // console.log("two");
    const conversionRateData = await conversionRate.json();
    // console.log("conversionRateData", conversionRateData);

    // Store the location data
    const locationData = {
      city: data.city,
      state: data.region,
      stateCode: data.region_code,
      country: data.country_name,
      countryCode: data.country_code,
      currency: data.currency,
      postalCode: data.postal,
      latitude: data.latitude,
      longitude: data.longitude,
      timezone: data.timezone,
      conversionRate: conversionRateData.responseObject.rate,
    };

    // Save to localStorage to prevent repeated API calls
    localStorage.setItem("userLocation", JSON.stringify(locationData));
    dispatch(setLocationData(locationData));
  } catch (error) {
    console.error("Error fetching location:", error);
    dispatch(setError(error.message));
    toast.error("Failed to fetch location data");
  }
};

export default locationSlice.reducer;
